import { render } from "./OrgSelector.vue?vue&type=template&id=e6da6c52&scoped=true"
import script from "./OrgSelector.vue?vue&type=script&lang=js"
export * from "./OrgSelector.vue?vue&type=script&lang=js"

import "./OrgSelector.vue?vue&type=style&index=0&id=e6da6c52&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6da6c52"]])

export default __exports__